<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('form_placeholder_keyword') ||
                  '搜索发运单号/外运编号/补货计划编号...'
              "
            />
            <b-input-group-append>
              <b-button
                variant="link"
                size="sm"
                class="search-dropdown-button"
                squared
                @click="openAdvqueryDialog"
              >
                {{ $l('INDEX.advanced_search') || '高级搜索' }}
              </b-button>
              <b-button variant="primary" size="sm" @click="query">
                <i class="fa fa-search" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>

    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :visible.sync="advqueryDialogVisible"
      width="900px"
      :close-on-click-modal="false"
      v-el-dialog-drag
      append-to-body
    >
      <el-form ref="advForm" :model="form" size="small">
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_shipmentStatus') || '发运状态'"
            >
              <dict-select
                v-model="form.listShipmentStatus"
                url="/sys/common/dict/system"
                :body="{ dictType: 'ECOM_SHIPMENT_STATUS' }"
                multiple
                clearable
                filterable
                style="width:100%"
                :placeholder="$l('form_placeholder_status') || '请选择状态'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_shipmentNo') || '发运单号'">
              <el-input
                v-model.trim="form.shipmentNo"
                clearable
                :placeholder="
                  $l('form_placeholder_shipmentNo') || '请输入发运单号'
                "
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_planNos') || '补货计划编号'">
              <el-input
                v-model.trim="form.planNos"
                clearable
                :placeholder="
                  $l('form_placeholder_planNos') || '请输入补货计划编号'
                "
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_transportNos') || '外运编号'">
              <el-input
                v-model.trim="form.transportNos"
                clearable
                :placeholder="
                  $l('form_placeholder_transportNos') || '请输入外运编号'
                "
                style="width:100%"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.table_label_created_by') || '创建人'"
            >
              <dict-select
                v-model="form.listCreateBy"
                url="/master/common/dict/baseUserSelect"
                multiple
                clearable
                filterable
                style="width:100%"
                :placeholder="$l('form_placeholder_createBy') || '请选择创建人'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.table_label_modified_by') || '修改人'"
            >
              <dict-select
                v-model="form.listModifyBy"
                url="/master/common/dict/baseUserSelect"
                multiple
                clearable
                filterable
                style="width:100%"
                :placeholder="$l('form_placeholder_modifyBy') || '请选择修改人'"
              />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_createTime') || '创建时间'"
            >
              <br />
              <el-row :gutter="10">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  />
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.createTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  />
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.form_label_modifyTime') || '修改时间'"
            >
              <br />
              <el-row :gutter="10">
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeStart"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
                <el-col class="line" :span="2">-</el-col>
                <el-col :span="11">
                  <el-date-picker
                    v-model="form.modifyTimeEnd"
                    type="date"
                    size="small"
                    value-format="yyyy-MM-dd"
                    :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                    style="width: 100%"
                  >
                  </el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
const initForm = {
  keyword: '',
  listShipmentStatus: [],
  shipmentNo: '',
  planNos: '',
  transportNos: '',
  listCreateBy: [],
  listModifyBy: [],
  createTimeStart: '',
  createTimeEnd: '',
  modifyTimeStart: '',
  modifyTimeEnd: '',
}

export default {
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    query({ isReset = true } = {}) {
      if (isReset) this.$emit('reset')
      this.$emit('query', { ...this.form })
    },
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0;
}
.line {
  text-align: center;
}
</style>
